module.exports = __webpack_public_path__ + "static/media/shipped.2bcd29a4.svg";